import Alert from 'react-bootstrap/Alert'
import Breadcrumb from './Breadcrumb'
import Card from 'react-bootstrap/Card'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import styles from '../styles/Error.module.scss'

const Error = ({ error }) => (
  <div className={styles.container}>
    <Breadcrumb />
    <div className={styles.headingContainer}>
      <h4 className='page-heading'>Error{!isNaN(error) && ` ${error}`}</h4>
    </div>
    <Card className='shadow-sm'>
      <Card.Body>
        {isNaN(error) && (
          <Alert className={styles.alert} variant='danger'>
            {error}
          </Alert>
        )}
        <div>
          The error has been recorded. New cards take a few days to show up on
          EDHREC. Otherwise, you can also{' '}
          <Link to='/bug-report'>report a bug</Link> to help us fix it faster.
        </div>
      </Card.Body>
    </Card>
  </div>
)

Error.propTypes = {
  error: PropTypes.oneOf([PropTypes.number, PropTypes.string]).isRequired,
}

export default Error
